import { Loader } from '@beholos/holoscommon';

interface StepThreeProps {
  nextStep: () => void;
  toggleDiscount: () => void;
  acceptedDiscount: boolean;
  discountedPrice: number;
  discountedCurrency?: string;
  planName?: string;
  cycleDuration?: number;
  numberOfPasses?: number;
  loading: boolean;
  disableCancellationDiscount: boolean;
}

const getCycleDurationQualifier = (cycleDuration?: number) => {
  if (cycleDuration === 1) return 'mes';
  if (cycleDuration === 3) return 'trimestral';
  return 'semestral';
};

const formatPrice = (price: number, currency = '$') => {
  return `${currency}${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const StepThree = ({
  nextStep,
  toggleDiscount,
  acceptedDiscount,
  discountedPrice,
  discountedCurrency,
  planName,
  cycleDuration,
  loading,
  disableCancellationDiscount
}: StepThreeProps) => (
  <div>
    <div className="font-medium text-lg text-black leading-tight mb-3">
      ¡Gracias por tus comentarios!
    </div>
    
    {!disableCancellationDiscount && (
      <div>
        <div className="text-sm text-black mb-2">
          Nos gustaría compensarte ofreciéndote{' '}
          <span className="text-holos-dark">
            el plan {planName}
            {cycleDuration && cycleDuration > 1 && (
              <span className="capitalize"> - {getCycleDurationQualifier(cycleDuration)}</span>
            )}{' '}
          </span>{' '}
          por solo{' '}
          <span className="text-holos-dark">
            {formatPrice(discountedPrice, discountedCurrency)}
          </span>
          : es decir <strong>15% menos del precio regular.</strong>
        </div>
        
        <div className="text-sm text-black mb-2">
          Podrás cancelar en cualquier momento.
        </div>
        
        <div className="font-bold text-sm text-black mt-4 mb-2">
          ¿Te gustaría aceptar el descuento?
        </div>
      </div>
    )}
    
    {disableCancellationDiscount && (
      <div className="text-md text-black mb-8">
        Click en confirmar a continuación para procesar su cancelación.
      </div>
    )}
    
    {!disableCancellationDiscount && (
      <div className="space-y-4 mb-6">
        <div
          onClick={() => !loading && toggleDiscount()}
          className={`relative flex items-center p-4 pl-12 border-2 rounded-lg cursor-pointer transition-colors ${
            acceptedDiscount 
              ? 'border-holos-dark bg-holos-dark/10' 
              : 'border-gray-300 hover:border-gray-400'
          } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <div className={`absolute left-4 w-6 h-6 rounded-full flex items-center justify-center ${
            acceptedDiscount ? 'bg-holos-dark' : 'bg-gray-300'
          }`}>
            {acceptedDiscount && (
              <span className="text-white text-sm">✓</span>
            )}
          </div>
          <div className="text-black font-semibold">
            Sí, por favor cambien mi plan a{' '}
            {formatPrice(discountedPrice, discountedCurrency)}.
          </div>
        </div>
        
        <div
          onClick={() => !loading && toggleDiscount()}
          className={`relative flex items-center p-4 pl-12 border-2 rounded-lg cursor-pointer transition-colors ${
            !acceptedDiscount 
              ? 'border-holos-dark bg-holos-dark/10' 
              : 'border-gray-300 hover:border-gray-400'
          } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <div className={`absolute left-4 w-6 h-6 rounded-full flex items-center justify-center ${
            !acceptedDiscount ? 'bg-holos-dark' : 'bg-gray-300'
          }`}>
            {!acceptedDiscount && (
              <span className="text-white text-sm">✓</span>
            )}
          </div>
          <div className="text-black font-semibold">
            No, quisiera cancelar mi suscripción
          </div>
        </div>
      </div>
    )}
    
    <button 
      className="w-full bg-holos-dark text-white py-3 px-4 rounded-lg font-semibold uppercase hover:bg-holos-dark/80 disabled:opacity-50 cursor-pointer" 
      disabled={loading} 
      onClick={nextStep}
    >
      Confirmar
    </button>

    {loading && (
      <div className="py-3 flex justify-center">
        <Loader />
      </div>
    )}
  </div>
);